import { CommonModule } from '@angular/common';
import { DoBootstrap, Injector, NgModule } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { MatExpansionModule } from '@angular/material/expansion';
import { NasModelModule } from '@sama/ng-app-state';
import { SharedModule } from '../../shared/shared.module';
import { H3mlModule } from '../h3ml/h3ml.module';
import { PreviewWorkspaceHostComponent } from './preview-workspace-host.component';
import { PreviewWorkspaceComponent } from './preview-workspace.component';

@NgModule({
  imports: [
    CommonModule,
    H3mlModule,
    MatExpansionModule,
    NasModelModule,
    SharedModule,
  ],
  declarations: [PreviewWorkspaceComponent, PreviewWorkspaceHostComponent],
  exports: [PreviewWorkspaceComponent, PreviewWorkspaceHostComponent],
})
export class PreviewWorkspaceModule implements DoBootstrap {
  constructor(private injector: Injector) {}

  ngDoBootstrap() {
    customElements.define(
      'ursa-preview-workspace',
      createCustomElement(PreviewWorkspaceHostComponent, {
        injector: this.injector,
      }),
    );
  }
}
